import { Component, ChangeDetectionStrategy} from '@angular/core';
import { IHeaderGroupAngularComp } from 'ag-grid-angular';
import {DomSanitizer} from "@angular/platform-browser";

@Component({ standalone: false,
  selector: 'com-pr-header-group',
  templateUrl: './com-pr-header-group.component.html',
  styleUrls: ['./com-pr-header-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComPrHeaderGroupComponent implements IHeaderGroupAngularComp {

  params: any;
  displayName: string;
  maxWidth = '300px';

  constructor(private sanitizer: DomSanitizer) {}

  agInit(params: any): void {
    this.params = params;
    this.displayName = params.value;
    this.maxWidth = this.params.maxWidth ? this.params.maxWidth : '300px';
  }
}
